import * as React from "react";
import { Link, IfPermitted, CountBadge } from "components/common";
import Routes from "routing/Routes";
const MAX_USERS = 5;
const UsersCell = ({ team, usersContext }) => {
  const users = team.users.take(MAX_USERS);
  const usersLength = users.size;
  const usersComponents = users.toArray().map((userId, index) => {
    var _a;
    const username = (_a = usersContext.get(userId)) == null ? void 0 : _a.title;
    if (!username) {
      return `${userId} (Name not found)`;
    }
    return /* @__PURE__ */ React.createElement(IfPermitted, { permissions: [`users:edit:${username}`], key: userId }, /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.USERS.show(userId) }, username), index < usersLength - 1 && ",  ");
  });
  if (team.users.size > MAX_USERS) {
    usersComponents.push(/* @__PURE__ */ React.createElement("span", { key: "dots" }, "..."));
  }
  return /* @__PURE__ */ React.createElement("td", { className: "limited" }, /* @__PURE__ */ React.createElement(CountBadge, { count: team.users.size }), " ", usersComponents);
};
export default UsersCell;
